import styled from 'styled-components';
import { colorBrandSecondary } from 'constants/colors';

const Link = styled.a`
  color: ${colorBrandSecondary};
  text-decoration: none;
`;

export default Link;
